/**
 * LennyText — renders a Lenny chat message for NiV screens:
 * line breaks preserved, **bold** honoured, URLs clickable. No other markdown.
 */

const LINK_SPLIT_REGEX = /(https?:\/\/[^\s)]+)/g;
const IS_LINK_REGEX = /^https?:\/\//;

const renderInline = (text, keyPrefix) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((chunk, i) => {
    if (chunk.startsWith("**") && chunk.endsWith("**")) {
      return <strong key={`${keyPrefix}-b${i}`}>{chunk.slice(2, -2)}</strong>;
    }
    return chunk.split(LINK_SPLIT_REGEX).map((part, j) => {
      if (!part) return null;
      if (IS_LINK_REGEX.test(part)) {
        return (
          <a
            key={`${keyPrefix}-l${i}-${j}`}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            dir="ltr"
          >
            {part}
          </a>
        );
      }
      return <span key={`${keyPrefix}-t${i}-${j}`}>{part}</span>;
    });
  });

function LennyText({ content, className = "" }) {
  const lines = String(content || "").split("\n");
  return (
    <div className={className}>
      {lines.map((line, idx) => (
        <div key={idx} dir="auto" style={{ minHeight: line ? undefined : "0.6em" }}>
          {renderInline(line, `ln${idx}`)}
        </div>
      ))}
    </div>
  );
}

export default LennyText;
